document.addEventListener("DOMContentLoaded", function () {
  var menu_open = false;
  var skipClose = false; // New flag to prevent closing when navigating to submenus

  function navigation_keyboard_traversal(event) {
    if (["ArrowDown", "ArrowUp", "Escape"].includes(event.code)) {
      event.preventDefault();
      var parent = event.target.parentNode;

      if (document.body.classList.contains('show-focus-outlines')) {
        switch (event.code) {
          case "ArrowDown":
            if (parent.classList.contains('menu-item-has-children')) {
              close_nav_menus(); // Close other menus

              parent.classList.add('keyboard-nav-toggle');
              menu_open = true;
            }

            var next = get_next_tabbable(event.target);
            next.focus();
            break;

          case 'ArrowUp':
            // Close menu if navigating upwards, logic remains unchanged
            close_nav_menus();
            break;

          case 'Escape':
            // Directly remove 'keyboard-nav-toggle' from all elements
            document.querySelectorAll('.keyboard-nav-toggle').forEach(function (menu) {
              menu.classList.remove('keyboard-nav-toggle');
            });
            menu_open = false; // Update the menu state

            break;
        }
      }
    }
  }

  function close_nav_menus() {
    if (skipClose) return; // Prevent closing if navigating between parent and submenu

    var open_menus = document.getElementsByClassName('keyboard-nav-toggle');

    if (open_menus.length > 0) {
      for (var i = 0; i < open_menus.length; i++) {
        var menu = open_menus[i];

        if (!menu.closest('.submenu')) {
          menu.classList.remove('keyboard-nav-toggle');
        }
      }

      menu_open = false;
    }
  }

  function get_next_tabbable(element) {
    var universe = document.querySelectorAll('input, button, select, textarea, a[href]');
    var list = Array.prototype.filter.call(universe, function (item) {
      return item.tabIndex >= "0";
    });
    var index = list.indexOf(element);
    return list[index + 1] || list[0];
  }

  function handleFocus(event) {
    var parentMenu = event.target.closest('.menu-item-has-children');

    if (parentMenu) {
      skipClose = true; // Focus within a parent or submenu
    } else {
      skipClose = false; // Focus outside the menus
    }
  } // Attach focus listeners to parent menus


  document.querySelectorAll('.menu-item-has-children').forEach(function (menu) {
    menu.addEventListener('focusin', handleFocus);
    menu.addEventListener('focusout', handleFocus);
  });
  document.getElementsByTagName('header')[0].addEventListener('keydown', navigation_keyboard_traversal);
  document.addEventListener('keydown', function (event) {
    if (event.code === 'Escape' && menu_open) {
      close_nav_menus();
    }
  });
});